import React from "react";

const Page = ({
  className,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => <div {...rest} className={`${className} min-h-screen pt-16 px-12`}></div>;

export default Page;
